export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * 上传单个词汇音频文件
     * @param nodeId 知识点ID
     * @param file 音频文件（mp3/wav）
     */
    uploadAudio: function uploadAudio(nodeId, file) {
      var formData = new FormData();
      formData.append('file', file);
      return request({
        url: "/api/vocabulary/audio/upload/".concat(nodeId),
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },

    /**
     * 获取词汇音频列表
     */
    getAudioList: function getAudioList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/vocabulary/audio/list',
        method: 'get',
        params: data
      });
    }
  };
});